import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const jupiterButtonFn = /* @__PURE__ */ createRecipe('jupiter-button', {
  "visual": "primary",
  "size": "md",
  "combo": "text"
}, [])

const jupiterButtonVariantMap = {
  "visual": [
    "primary",
    "secondary",
    "sitePrimary",
    "siteSecondary",
    "primaryText",
    "grey",
    "disable",
    "disableText",
    "link",
    "linkDark",
    "linkPrimary",
    "cancel"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "combo": [
    "icon",
    "text",
    "iconText"
  ]
}

const jupiterButtonVariantKeys = Object.keys(jupiterButtonVariantMap)

export const jupiterButton = /* @__PURE__ */ Object.assign(memo(jupiterButtonFn), {
  __recipe__: true,
  __name__: 'jupiterButton',
  raw: (props) => props,
  variantKeys: jupiterButtonVariantKeys,
  variantMap: jupiterButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, jupiterButtonVariantKeys)
  },
})